module.exports = __webpack_public_path__ + "media/flags/st-31589775.svg";